// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"363":"1052539c","453":"d855a71b","478":"eb105eac","510":"debcdeb4","541":"e4293f65","735":"b5cc80dc","805":"58204ace","868":"f986050c"}[chunkId] + ".chunk.js";
};